import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useGeIsTeammateAdmin } from '../../../../api/teammates/hooks';
import {
  useGetUserPaymentMethodsQuery,
  useMeQuery,
  useRemovePaymentMethodMutation,
  useSetUserDefaultPaymentMethodMutation,
} from '../../../../api/user';
import { RestaurantUser } from '../../../../api/user/types';
import SvgTrash from '../../../../assets/icons/Trash';
import { ThemedButton } from '../../../../shared/components/themed-button';
import { Dialog } from '../../../../shared/components/dialog';
import { ToastService } from '../../../../shared/services/toastService';
import { useAppSelector } from '../../../../store';
import { getIsRestaurant } from '../../../../store/user';

import { useStyles } from './style';
import { AddPaymentBanner } from './add-payment-banner';

export enum MethodType {
  card = 'credit_card',
  account = 'on_account',
}

export const PaymentMethods: React.FC = () => {
  const { push } = useHistory();
  const classes = useStyles();
  const isRestaurant = useAppSelector(getIsRestaurant);

  const [currentId, setCurrentId] = useState<string | undefined>();

  const { data: user } = useMeQuery();
  const isAdminTeammate = useGeIsTeammateAdmin();
  const isViewer = !isAdminTeammate;
  const stripe_id = isRestaurant ? (user as RestaurantUser)?.stripe_id : null;
  const { data } = useGetUserPaymentMethodsQuery((user as RestaurantUser)?.stripe_id as string, { skip: !(user as RestaurantUser)?.stripe_id });
  const [removeCard] = useRemovePaymentMethodMutation();
  const [setDefault] = useSetUserDefaultPaymentMethodMutation();

  const onRemoveCard = () => {
    if (isViewer) {
      ToastService.error('You have been restricted from making edits.');
      return;
    }
    currentId && stripe_id && removeCard({ method_id: currentId, stripe_id });
    setCurrentId(undefined);
  };
  const openAddPayment = () => {
    if (isViewer) {
      ToastService.error('You have been restricted from making edits.');
      return;
    }
    push('/account/billing/payment/add');
  };

  const onSetDef = (e: any, method_id: string) => {
    if (isViewer) {
      ToastService.error('You have been restricted from making edits.');
      return;
    }
    e.stopPropagation();
    stripe_id &&
      setDefault({
        stripe_id,
        method_id,
      });
  };

  return (
    <div className={classes.root}>
      <AddPaymentBanner onBtnClick={openAddPayment} />
      <div className={classes.paymentMethodsList}>
        {Array.isArray(data?.payment_methods)
          ? data?.payment_methods.map((el) => (
              <div className={classes.paymentMethod} key={el.id}>
                <div className={classes.paymentMethodContent}>
                  <div className={classes.paymentMethodName}>
                    <span>{el.billing_details?.name}</span>
                  </div>
                  <div className={classes.paymentMethodInfo}>
                    <span className={classes.greyText}>{el.card?.brand || 'Card'}</span>
                    <span className={classes.greyText}>**** {el.card?.last4}</span>
                  </div>
                </div>
                <div className={classes.action}>
                  {data?.default_method === el.id ? (
                    <div className={classes.defaultBadge}>Default</div>
                  ) : (
                    <ThemedButton onClick={(e) => onSetDef(e, el.id as string)} title='Set as Default' buttonStyle='blueTransparent' />
                  )}
                </div>
                <SvgTrash className={classes.deletePaymentMethod} onClick={setCurrentId.bind(null, el.id)} />
              </div>
            ))
          : null}
      </div>
      {!!currentId && (
        <Dialog
          title={`Are you sure you want to delete this payment method`}
          onConfirm={onRemoveCard}
          onCancel={setCurrentId.bind(null, undefined)}
          customClass={classes.dialog}
        />
      )}
    </div>
  );
};
